module.exports = __webpack_public_path__ + "static/img/new04.b257708e.png";